import { Instance } from 'mobx-state-tree';
import { PlanningActionMetadataReOptimizeTargetRouteDtoModelBase } from './PlanningActionMetadataReOptimizeTargetRouteDtoModel.base';

/* The TypeScript type of an instance of PlanningActionMetadataReOptimizeTargetRouteDtoModel */
export interface PlanningActionMetadataReOptimizeTargetRouteDtoModelType extends Instance<typeof PlanningActionMetadataReOptimizeTargetRouteDtoModel.Type> {}

/* A graphql query fragment builders for PlanningActionMetadataReOptimizeTargetRouteDtoModel */
// eslint-disable-next-line max-len
export { selectFromPlanningActionMetadataReOptimizeTargetRouteDto, planningActionMetadataReOptimizeTargetRouteDtoModelPrimitives, PlanningActionMetadataReOptimizeTargetRouteDtoModelSelector } from './PlanningActionMetadataReOptimizeTargetRouteDtoModel.base';

/**
 * PlanningActionMetadataReOptimizeTargetRouteDtoModel
 */
export const PlanningActionMetadataReOptimizeTargetRouteDtoModel = PlanningActionMetadataReOptimizeTargetRouteDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
